module.exports = __webpack_public_path__ + "assets/images/signup-parent.4fbf9bd26c797bf5f578d4e88c6f3b78.svg";